<template>
 <div class="MainBodyBox">
  <router-view style="width: 100%;height: 100%;"/>
  <!-- 智能助手悬浮球 + 对话框 -->
  <AiAssistant />
 </div>

</template>

<script setup>
import AiAssistant from './components/AiAssistant.vue';
</script>

<style>
.MainBodyBox {
  width: 100vw;
  height: 100vh;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
